var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMileage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.999,
    height: 75.087,
    viewBox: "0 0 79.999 75.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.001 -0.001)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4874",
    "data-name": "Group 4874",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2817",
    "data-name": "Path 2817",
    d: "M20.1,16.63v.016Z",
    transform: "translate(1.269 -3.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M25.28,37.012l1.564,8.447a10.95,10.95,0,0,1,17.927,0l1.564-8.447L35.792,33.07Z",
    transform: "translate(4.192 6.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2819",
    "data-name": "Path 2819",
    d: "M27,47.822A7.822,7.822,0,1,0,34.822,40,7.822,7.822,0,0,0,27,47.822Zm10.95,0a3.129,3.129,0,1,1-3.129-3.129A3.129,3.129,0,0,1,37.95,47.822Z",
    transform: "translate(5.162 10.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2820",
    "data-name": "Path 2820",
    d: "M42.053,26.6a18.944,18.944,0,0,1-4.693,3.348l3.88,1.408.876-4.787Z",
    transform: "translate(11.009 2.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M26.227,35.73h.016l.8-.3-.563-3.113L15.84,36.184l1.079,2.941Z",
    transform: "translate(-1.135 5.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2822",
    "data-name": "Path 2822",
    d: "M41,35.433l.8.3h.016l9.308,3.395L52.2,36.184,41.579,32.32Z",
    transform: "translate(13.063 5.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M23.688,26.61a.156.156,0,0,1-.078,0l.876,4.787,3.88-1.408a19.366,19.366,0,0,1-4.677-3.379Z",
    transform: "translate(3.249 2.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M32.549,32.831,31.517,30,24.54,32.534l.579,3.082Z",
    transform: "translate(3.774 4.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M41.771,35.616l.579-3.082L35.372,30,34.34,32.831Z",
    transform: "translate(9.305 4.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M42.763,12.707l23.465,8.51,1.064-2.941L40.808,8.64l-.438,1.2a19.038,19.038,0,0,1,2.393,2.863Z",
    transform: "translate(12.707 -7.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2827",
    "data-name": "Path 2827",
    d: "M41.437,36.3,39.2,48.345H54.014l-2.331-8.2Z",
    transform: "translate(12.047 7.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2828",
    "data-name": "Path 2828",
    d: "M39.9,55.386A10.95,10.95,0,0,1,29.06,46H18v9.777l5.866,5.866H55.935L61.8,55.777V46H50.741A10.95,10.95,0,0,1,39.9,55.386Z",
    transform: "translate(0.084 13.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M30.144,48.345,27.907,36.3,17.661,40.148l-2.331,8.2H30.144Z",
    transform: "translate(-1.423 7.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M45.133,18.192,55.9,22.1a1.564,1.564,0,1,1-1.064,2.941l-9.574-3.5a19.178,19.178,0,0,1-1.1,5.225l8.666,3.129a1.564,1.564,0,1,1-1.064,2.941l-8.2-2.988-1.8,9.714,11.122,4.052,8.572-23.465L44.148,13.89a19.319,19.319,0,0,1,.986,4.3Z",
    transform: "translate(13.498 -4.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2831",
    "data-name": "Path 2831",
    d: "M29.375,39.581,18.252,43.632,9.68,20.167,27,13.91a18.521,18.521,0,0,0-1.048,4.364L15.186,22.185a1.564,1.564,0,1,0,1.064,2.941l9.574-3.6a18.772,18.772,0,0,0,1.111,5.225l-8.666,3.129a1.564,1.564,0,1,0,1.064,2.941l8.2-2.988.97,5.287-7.055,2.612a1.564,1.564,0,1,0,1.064,2.941l6.617-2.409Z",
    transform: "translate(-4.612 -4.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2832",
    "data-name": "Path 2832",
    d: "M22,23.643A15.643,15.643,0,1,0,37.643,8,15.643,15.643,0,0,0,22,23.643Zm15.643-3.129a3.129,3.129,0,1,1-3.129,3.129A3.129,3.129,0,0,1,37.643,20.515Z",
    transform: "translate(2.341 -8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2833",
    "data-name": "Path 2833",
    d: "M33.331,9.845l-.438-1.2L6.44,18.276,7.5,21.217l23.465-8.51a19.038,19.038,0,0,1,2.362-2.863Z",
    transform: "translate(-6.44 -7.639)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileage);
export default __webpack_public_path__ + "static/media/mileage.179c30959319411245b00fd56ec03b5c.svg";
export { ForwardRef as ReactComponent };